import { createPromotionRequest } from '../models/promotion-request.js';
import { PromotionStatus, RegimeStatus } from './constants.js';
import { evaluatePredicates, failedReasonCodes } from './predicates.js';

export function buildPromotionRequest({ requestId, trace, requestedAt, requestedBy = 'scenario-runner', regime, stabilizationRequirement, directRecallAttempt = false, directReflexAttempt = false, evaluationBinding }) {
  const predicateResults = evaluatePredicates({
    evidence: trace.evidenceLedger, regime, stabilizationRequirement, directRecallAttempt, directReflexAttempt
  });
  const reasonCodes = failedReasonCodes(predicateResults);
  const predicatesSatisfied = reasonCodes.length === 0;
  return {
    request: createPromotionRequest({
      requestId, traceId: trace.traceId, requestedAt, requestedBy,
      ...evaluationBinding,
      evidenceDimensionIds: [...new Set(trace.evidenceLedger.map((item) => item.dimension))],
      provenanceStatus: predicateResults.provenanceComplete ? 'COMPLETE' : 'INCOMPLETE',
      regimeSnapshot: regime,
      recallDerivedInputPresent: trace.evidenceLedger.some((item) => item.recallDerived),
      reflexOriginatedInputPresent: trace.evidenceLedger.some((item) => item.reflexOriginated),
      predicateResults,
      governanceStatus: predicatesSatisfied ? PromotionStatus.AWAITING_GOVERNANCE : PromotionStatus.PREDICATES_FAILED,
      quarantineStatus: 'CLEAR'
    }),
    reasonCodes,
    predicatesSatisfied
  };
}

export function advanceRegime(regime, stabilizationRequirement = 5) {
  if (regime.status === RegimeStatus.UNSTABLE) throw new Error('STABILIZATION_NOT_STARTED');
  if (regime.status === RegimeStatus.STABILIZING) {
    const stableSteps = Math.min(stabilizationRequirement, regime.stableSteps + 1);
    return Object.freeze({ status: stableSteps >= stabilizationRequirement ? RegimeStatus.STABLE : RegimeStatus.STABILIZING, stableSteps, stabilizationRequirement });
  }
  return Object.freeze({ ...regime, stabilizationRequirement });
}
